import { Dog, Eye, EyeOff, Lock, Mail } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/LoginPage.css";
import { supabase } from "../lib/supabaseClient.ts";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    // Query Supabase login table for matching email
    const { data, error: supabaseError } = await supabase
      .from("login")
      .select("email, password")
      .eq("email", email.trim().toLowerCase())
      .single();

    if (supabaseError) {
      setError("Erreur serveur. Veuillez réessayer.");
      setIsLoading(false);
      return;
    }

    if (!data) {
      setError("Email ou mot de passe incorrect.");
      setIsLoading(false);
      return;
    }

    // Compare plain password directly
    if (password === data.password) {
      localStorage.setItem("isAuthenticated", "true");
      navigate("/admin/slider");
    } else {
      setError("Email ou mot de passe incorrect.");
    }

    setIsLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        {/* Left Brand */}
        <div className="brand-section">
          <div className="brand-header">
            <Dog className="h-12 w-12 mr-3" />
            <div>
              <h1 className="brand-title">Animalia</h1>
              <p className="brand-subtitle">Boutique pour Animaux</p>
            </div>
          </div>
          <p className="brand-text">
            Votre animalerie en ligne dédiée au bien-être de vos compagnons. Connectez-vous pour accéder à votre espace personnalisé.
          </p>
          <div>
            <div className="brand-feature"><span></span> Produits de qualité pour tous les animaux</div>
            <div className="brand-feature"><span></span> Livraison rapide et fiable</div>
            <div className="brand-feature"><span></span> Conseils et soins pour vos compagnons</div>
          </div>
        </div>

        {/* Right Login Form */}
        <div className="login-form-section">
          <h2 className="login-title">Connexion</h2>
          <p className="login-subtitle">Accédez à votre espace personnel</p>

          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <p className="text-red-600 text-sm mb-4" role="alert">{error}</p>
            )}

            <div>
              <label className="input-label" htmlFor="email">Adresse email</label>
              <div className="input-wrapper">
                <Mail className="input-icon" />
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input-field"
                  placeholder="votre@email.com"
                  required
                />
              </div>
            </div>

            <div>
              <label className="input-label" htmlFor="password">Mot de passe</label>
              <div className="input-wrapper">
                <Lock className="input-icon" />
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="input-field"
                  placeholder="••••••••"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="password-toggle"
                  aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                >
                  {showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="login-button"
            >
              {isLoading ? "Connexion..." : "Se connecter"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
